import * as React from "react";
import PropTypes from 'prop-types';

const SvgClear = props => {
  if (props.id !== "_svgclear") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 12 12" {...props}><g transform="translate(-.25 -.25)" fill="none" fillRule="evenodd"><circle fill="#384048" cx={6.25} cy={6.25} r={6} /><path d="M4.19 3.407l2.07 2.071L8.31 3.43a.536.536 0 01.759.758l-2.05 2.05 2.075 2.074a.536.536 0 11-.758.758L6.261 6.995 4.164 9.093a.536.536 0 01-.758-.758l2.097-2.098L3.43 4.165a.536.536 0 01.758-.758z" fill="#FFF" /></g></svg>;
};

SvgClear.displayName = "_svgclear";
SvgClear.propTypes = {
  id: PropTypes.string
};
SvgClear.defaultProps = {
  id: ''
};
export default SvgClear;